var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg15(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5296_675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1654 7.99967C14.1654 4.59392 11.4045 1.83301 7.9987 1.83301C4.59294 1.83301 1.83203 4.59392 1.83203 7.99967C1.83203 11.4054 4.59294 14.1663 7.9987 14.1663C11.4045 14.1663 14.1654 11.4054 14.1654 7.99967ZM7.4987 10.6663V7.99967C7.4987 7.72353 7.72256 7.49967 7.9987 7.49967C8.27484 7.49967 8.4987 7.72353 8.4987 7.99967V10.6663C8.4987 10.9425 8.27484 11.1663 7.9987 11.1663C7.72256 11.1663 7.4987 10.9425 7.4987 10.6663ZM8.00521 4.83301C8.28135 4.83301 8.50521 5.05687 8.50521 5.33301C8.50521 5.60915 8.28135 5.83301 8.00521 5.83301H7.9987C7.72256 5.83301 7.4987 5.60915 7.4987 5.33301C7.4987 5.05687 7.72256 4.83301 7.9987 4.83301H8.00521ZM15.1654 7.99967C15.1654 11.9577 11.9567 15.1663 7.9987 15.1663C4.04066 15.1663 0.832031 11.9577 0.832031 7.99967C0.832031 4.04163 4.04066 0.833008 7.9987 0.833008C11.9567 0.833008 15.1654 4.04163 15.1654 7.99967Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5296_675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg15);
export default __webpack_public_path__ + "static/media/svg15.401e4089c24bb0ce70b70e8082cb9846.svg";
export { ForwardRef as ReactComponent };